<template>
  <div class="tc-button__loading">
    <TcLottieWeb class="tc-button__loading-inner" :animation-data="aniData" :auto-play="true" :loop="true" :speed="1" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { TcLottieWeb } from '@overseas/tcdesign';
import { replaceColor } from 'lottie-colorify';

import loadingWhite from '~/assets/ani/loading_white.json';
// import loadingGray from '@/assets/ani/loading_gray.json';

export default defineComponent({
  name: 'BtnLoading',
  components: {
    TcLottieWeb,
  },
  props: {
    type: {
      type: String,
      default: 'default',
    },
    color: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    let aniData = /*  props.type === 'default' ? loadingGray : */ loadingWhite;
    if (props.type === 'default') {
      aniData = replaceColor('#ffffff', props.color || '#c1c1c1', loadingWhite as any);
    }
    return {
      aniData,
    };
  },
});
</script>
